export default function TimeSheetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 27 32"
      fill="none"
    >
      <path
        d="M26.1907 7.92898L18.453 0.191312C18.3305 0.0688124 18.1643 0 17.9912 0H3.17387C1.42381 0 0 1.42387 0 3.17399V28.8261C0 30.5761 1.42381 32 3.17393 32H23.2081C24.9581 32 26.382 30.5762 26.382 28.8261V8.3908C26.382 8.21761 26.3131 8.05148 26.1907 7.92898ZM18.6443 2.22987H18.6444L24.1523 7.73774H20.5121C20.0131 7.73774 19.544 7.54342 19.1913 7.19067C18.8386 6.83799 18.6443 6.36893 18.6443 5.86999V2.22987ZM25.0759 28.826C25.0758 29.8559 24.238 30.6938 23.2081 30.6938H3.17387C2.14393 30.6938 1.30606 29.8559 1.30606 28.826V3.17399C1.30612 2.14406 2.144 1.30612 3.17387 1.30612H17.3383V5.86993C17.3382 6.71774 17.6683 7.5148 18.2678 8.11423C18.8672 8.71373 19.6643 9.04386 20.5122 9.04386H25.0759V28.826Z"
        fill="#212121"
      />
      <path
        d="M20.7461 13.0664H5.63597C5.27528 13.0664 4.98291 13.3588 4.98291 13.7195V22.6221C4.98291 22.9828 5.27528 23.2751 5.63597 23.2751H20.7461C21.1068 23.2751 21.3992 22.9828 21.3992 22.6221V13.7195C21.3992 13.3588 21.1068 13.0664 20.7461 13.0664ZM12.538 21.9691H6.28897V20.3083H12.538V21.9691ZM12.538 19.0022H6.28897V17.3393H12.538V19.0022ZM12.538 16.0332H6.28897V14.3725H12.538V16.0332ZM20.0931 21.9691H13.8441V20.3083H20.0931V21.9691ZM20.0931 19.0022H13.8441V17.3393H20.0931V19.0022ZM20.0931 16.0332H13.8441V14.3725H20.0931V16.0332Z"
        fill="#212121"
      />
      <path
        d="M5.92822 24.5547H5.63585C5.27516 24.5547 4.98279 24.8471 4.98279 25.2077C4.98279 25.5684 5.27516 25.8608 5.63585 25.8608H5.92822C6.28891 25.8608 6.58128 25.5684 6.58128 25.2077C6.58128 24.8471 6.28891 24.5547 5.92822 24.5547Z"
        fill="#212121"
      />
      <path
        d="M14.3842 24.5547H8.041C7.68031 24.5547 7.38794 24.8471 7.38794 25.2077C7.38794 25.5684 7.68031 25.8608 8.041 25.8608H14.3842C14.7449 25.8608 15.0373 25.5684 15.0373 25.2077C15.0373 24.8471 14.7449 24.5547 14.3842 24.5547Z"
        fill="#212121"
      />
    </svg>
  );
}
